export default __webpack_public_path__ + "static/media/money_market_dark.bfd28127.png";